import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";
import dayjs from "dayjs";
import store from "@/store";

Vue.prototype.$cupom_desconto = new Vue({
  data() {
    return {
      cupom_loja: [],
      cupom_loja_loading: false,
      pesquisar_loading: false,
      variations: [],
      variations_loading: false,
      dayjs,
      status: [
        {
          key: "Ativo",
          value: "ATIVO",
        },
        {
          key: "Inativo",
          value: "INATIVO",
        },
      ],
      tipo_desconto: [
        {
          key: "Valor",
          value: "VALOR",
        },
        {
          key: "Percentual",
          value: "PERCENTUAL",
        },
      ],
      canal_venda: [
        { text: "Loja", value: "LOJA" },
        { text: "Marketplace", value: "MARKETPLACE" },
      ],
      edit_button_loading: false,
      loja_selecionada: "",
      loja_nome: "",
      text: "",
      idcupom: "",
      modalSelectStore: false,
      ENDPOINTS,
      cupomAddEdit: "new",
      filter: {
        canal_venda: "LOJA",
        loja: null,
        codigo: "",
        dthr_val_ini: "",
        dthr_val_fim: "",
        error: {
          loja: [],
        },
      },
      cadastro: {
        loading: false,
        loja: null,
        produto: [],
        variacao: [],
        status: "ATIVO",
        tipo_desconto: "VALOR",
        codigo: "",
        valor_desconto: 0,
        perc_desconto: 0,
        valor_max_desconto: 0,
        valor_min_desconto: 0,
        marketplace: false,
        dthr_val_ini: "",
        dthr_val_fim: "",
        quantidade: null,
        limite_uso: null,
        documentos: null,
        error: {
          loja: [],
          produto: [],
          variacao: [],
          codigo: [],
          status: [],
          dthr_val_ini: [],
          dthr_val_fim: [],
          valor_max_desconto: [],
          valor_min_desconto: [],
          valor_desconto: [],
          perc_desconto: [],
        },
      },
    };
  },
  methods: {
    getEnviroment() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      else return false;
    },
    getLojaID() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.getLocal("loja_cupom_selecionada").data;
      else return this.$axios.getLocal("oe_user_info")?.data?.loja;
    },
    getCupomByID(loja, idcupom, type, index) {
      this.cupomAddEdit = type;
      if (type === "editar" && loja === "" && idcupom === "") return;

      if (type === "new") {
        router.push({
          name: "discountCouponSettings",
          params: {
            type: "cadastrar",
          },
        });
      } else {
        this.cupom_loja[index].edit_button_loading = true;
        this.$axios.setLocal("id_produto", idcupom);
        this.$axios.get(this.ENDPOINTS.GET_CUPOM + idcupom).then(data => {
          router.push({
            name: "discountCouponSettings",
            params: {
              type: "editar",
            },
          });
          this.cadastro.loja = data.loja;
          this.cadastro.codigo = data.codigo;
          this.cadastro.status = data.status;
          this.cadastro.quantidade = data.quantidade;
          this.cadastro.limite_uso = data.limite_uso;
          this.cadastro.documentos = data.documentos;
          this.cadastro.produto = data.nidproduto;
          this.cadastro.variacao = data.nidprod_variacao;
          this.cadastro.valor_desconto = data.valor_desconto;
          this.cadastro.perc_desconto = data.perc_desconto;
          this.cadastro.valor_min_desconto = data.valor_min_pedido;
          this.cadastro.valor_max_desconto = data.valor_max_desconto;
          this.cadastro.marketplace = data.loja == null ? true : false;
          this.idcupom = data.idcupom;
          if (data.dthr_validade_ini) {
            this.cadastro.dthr_val_ini = data.dthr_validade_ini
              ? this.dayjs(data.dthr_validade_ini).format("DD/MM/YYYY HH:mm")
              : null;
          }
          if (data.dthr_validade_fim) {
            this.cadastro.dthr_val_fim = data.dthr_validade_fim
              ? this.dayjs(data.dthr_validade_fim).format("DD/MM/YYYY HH:mm")
              : null;
          }
          data.valor_max_desconto > 0
            ? (this.cadastro.tipo_desconto = "PERCENTUAL")
            : "VALOR";
          this.cupom_loja[index].edit_button_loading = false;
        });
      }
    },

    listarCupom() {
      this.cupom_loja_loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_CUPOM).then(res => {
        this.cupom_loja_loading = false;
        this.cupom_loja = res;
      });
    },

    async validarCadastro(type, $i18n) {
      if (this.cadastro.codigo === "") {
        this.$config.alert(
          $i18n.t("sales.empty_coupon_field"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.codigo = $i18n.t("sales.empty_coupon_field");
        return;
      }

      if (this.cadastro.codigo.length < 4) {
        this.cadastro.error.codigo = $i18n.t("sales.short_coupon_field");
        return;
      }

      if (this.cadastro.status === "") {
        this.$config.alert(
          $i18n.t("sales.coupon_status_validation"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.status = $i18n.t("sales.coupon_status_validation");
        return;
      }

      if (
        this.cadastro.dthr_val_ini !== null &&
        this.cadastro.dthr_val_ini.length < 10
      ) {
        this.$config.alert(
          $i18n.t("sales.coupon_expiration_start_validation"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.dthr_val_ini = $i18n.t(
          "sales.coupon_expiration_start_validation"
        );
        return;
      }
      if (
        this.cadastro.dthr_val_fim !== null &&
        this.cadastro.dthr_val_fim.length < 10
      ) {
        this.$config.alert(
          $i18n.t("sales.coupon_expiration_finish_validation"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.dthr_val_fim = $i18n.t(
          "sales.coupon_expiration_finish_validation"
        );
        return;
      }
      if (this.cadastro.tipo_desconto === "VALOR") {
        if (this.cadastro.valor_desconto <= 0) {
          {
            this.$config.alert(
              $i18n.t("sales.coupon_discount_value_validation"),
              this.$config.dados.errorColor
            );
            this.cadastro.error.valor_desconto = $i18n.t(
              "sales.coupon_discount_value_validation"
            );
            return;
          }
        }

        if (this.cadastro.valor_min_desconto === 0) {
          {
            this.$config.alert(
              $i18n.t("sales.coupon_min_discount_validation"),
              this.$config.dados.errorColor
            );
            this.cadastro.error.valor_min_desconto = $i18n.t(
              "sales.coupon_min_discount_validation"
            );
            return;
          }
        }
      } else {
        if (this.cadastro.perc_desconto <= 0) {
          {
            this.$config.alert(
              $i18n.t("sales.coupon_percent_discount_validation"),
              this.$config.dados.errorColor
            );
            this.cadastro.error.perc_desconto = $i18n.t(
              "sales.coupon_percent_discount_validation"
            );
            return;
          }
        }
        if (
          this.cadastro.valor_max_desconto === 0 ||
          /^0+$/.test(this.cadastro.valor_max_desconto)
        ) {
          {
            this.$config.alert(
              $i18n.t("sales.coupon_max_value_validation"),
              this.$config.dados.errorColor
            );
            this.cadastro.error.valor_max_desconto = $i18n.t(
              "sales.coupon_max_value_validation"
            );
            return;
          }
        }
      }

      if (type === "editar") {
        this.alterarCupom();
        return;
      }

      this.cadastrarCupom();
    },

    async cadastrarCupom() {
      this.cadastro.loading = true;
      let dados = {
        codigo: this.cadastro.codigo,
        status: this.cadastro.status,
        nidproduto: this.cadastro.produto.map(prod => {
          return prod.idproduto;
        }),
        nidprod_variacao: this.cadastro.variacao,
        loja: this.cadastro.marketplace ? null : store.getters.storeSequencial,
        dthr_validade_ini: this.cadastro.dthr_val_ini
          ? this.cadastro.dthr_val_ini.length < 16
            ? this.$config.convertDataEN(this.cadastro.dthr_val_ini) + " 00:00"
            : this.$config.convertDataEN(
                this.cadastro.dthr_val_ini.split(" ")[0]
              ) +
              " " +
              this.cadastro.dthr_val_ini.split(" ")[1]
          : null,
        dthr_validade_fim: this.cadastro.dthr_val_fim
          ? this.cadastro.dthr_val_fim.length < 16
            ? this.$config.convertDataEN(this.cadastro.dthr_val_fim) + " 23:59"
            : this.$config.convertDataEN(
                this.cadastro.dthr_val_fim.split(" ")[0]
              ) +
              " " +
              this.cadastro.dthr_val_fim.split(" ")[1]
          : null,
        quantidade: this.cadastro.quantidade,
        limite_uso: this.cadastro.limite_uso,
        documentos: this.cadastro.documentos,
        valor_desconto: Number(this.cadastro.valor_desconto),
        perc_desconto: Number(this.cadastro.perc_desconto),
        valor_max_desconto: Number(this.cadastro.valor_max_desconto),
        valor_min_pedido: Number(this.cadastro.valor_min_desconto),
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_CUPOM, dados)
        .then(res => {
          if (!res) {
            throw new Error();
          }
          router.push({ name: "discountCoupon" });
          this.cadastro.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async alterarCupom() {
      this.cadastro.loading = true;
      let dados = {
        idcupom: this.idcupom,
        codigo: this.cadastro.codigo,
        status: this.cadastro.status,
        nidproduto: this.cadastro.produto.map(prod => {
          return prod.idproduto;
        }),
        nidprod_variacao: this.cadastro.variacao,
        loja: this.cadastro.marketplace ? null : store.getters.storeSequencial,
        dthr_validade_ini: this.cadastro.dthr_val_ini
          ? this.cadastro.dthr_val_ini.length < 16
            ? this.$config.convertDataEN(this.cadastro.dthr_val_ini) + " 00:00"
            : this.$config.convertDataEN(
                this.cadastro.dthr_val_ini.split(" ")[0]
              ) +
              " " +
              this.cadastro.dthr_val_ini.split(" ")[1]
          : null,
        dthr_validade_fim: this.cadastro.dthr_val_fim
          ? this.cadastro.dthr_val_fim.length < 16
            ? this.$config.convertDataEN(this.cadastro.dthr_val_fim) + " 23:59"
            : this.$config.convertDataEN(
                this.cadastro.dthr_val_fim.split(" ")[0]
              ) +
              " " +
              this.cadastro.dthr_val_fim.split(" ")[1]
          : null,
        quantidade: this.cadastro.quantidade,
        limite_uso: this.cadastro.limite_uso,
        documentos: this.cadastro.documentos,
        valor_desconto: Number(this.cadastro.valor_desconto),
        perc_desconto: Number(this.cadastro.perc_desconto),
        valor_max_desconto: Number(this.cadastro.valor_max_desconto),
        valor_min_pedido: Number(this.cadastro.valor_min_desconto),
      };

      this.$axios
        .post(this.ENDPOINTS.ALTERAR_CUPOM, dados)
        .then(res => {
          if (!res) {
            throw new Error();
          }
          this.cadastro.loading = false;
          router.push({ name: "discountCoupon" });
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * @description Método para abrir o modal de confirmação de remoção de produto
     * @param {id} String - ID do produto
     * @param {msg} String - Mensagem de confirmação
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idcupom = id;
    },

    /**
     * @description Método de confirmação de remoção de produto
     */
    funcaoRemover() {
      this.deletarCupom(this.cadastro.idcupom);
    },

    deletarCupom(idcupom) {
      this.$axios.delete(this.ENDPOINTS.DELETAR_CUPOM + idcupom).then(() => {
        this.filtroCupom();
      });
    },

    /**
     * @description Método filtrar produtos
     */
    filtroCupom() {
      this.pesquisar_loading = true;
      let filtros = {
        loja: store.getters.storeSequencial,
      };

      if (this.filter.canal_venda == "MARKETPLACE") {
        filtros.loja = -1;
      } else if (this.filter.loja !== "") {
        this.filter.loja = filtros.loja;
      } else if (!this.getEnviroment()) {
        filtros.loja = this.getLojaID();
      }
      if (this.filter.codigo != "") {
        filtros.codigo = this.filter.codigo;
      }
      if (this.filter.dthr_val_ini !== "") {
        filtros.dthr_validade_ini = this.$config.convertDataEN(
          this.filter.dthr_val_ini
        );
      }
      if (this.filter.dthr_val_fim !== "") {
        filtros.dthr_validade_fim = this.$config.convertDataEN(
          this.filter.dthr_val_fim
        );
      }

      this.$axios
        .post(this.ENDPOINTS.LISTAR_CUPOM, filtros)
        .then(res => {
          this.cupom_loja = res;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.pesquisar_loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para repôr caracteres especiais em um texto
     * @param {str} String - string a ser reposta
     */
    replaceSpecialCharsAndSpaces(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str.replace(" ", "-");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "-");
    },

    /**
     * @description Método para transformar uma string em slug
     * @param {str} String - string a ser transformada
     */
    transformToSlug(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[êéêë]/, "e");
      str = str.replace(/[íì]/, "i");
      str = str.replace(/[ÍÌ]/, "i");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str.replace(":", "");
      str = str.replace("-", "");
      str = str.replace("- ", "");
      str = str.replace(" ", "-");

      return str.replace(/[^a-z0-9]/gi, "-");
    },

    /**
     * @description Método para transformar um array em uma string
     * @param {array} String - array a ser transformado
     */
    transformArrayInString(array) {
      let string = "";
      for (let i = 0; i < array.length; i++) {
        string += array[i];
        if (i < array.length - 1) {
          string += "";
        }
      }
      return string;
    },
    clearFieldsCupom(type) {
      switch (type) {
        case "FILTROS":
          this.filter.canal_venda = "LOJA";
          this.filter.codigo = "";
          this.filter.dthr_val_ini = "";
          this.filter.dthr_val_fim = "";
          this.filter.loja = "";
          this.filter.error.loja = [];
          this.cupom_loja = [];
          break;
        case "CADASTRO":
          this.cadastro.status = "ATIVO";
          this.cadastro.tipo_desconto = "VALOR";
          this.cadastro.codigo = "";
          this.cadastro.valor_desconto = 0;
          this.cadastro.perc_desconto = 0;
          this.cadastro.valor_max_desconto = 0;
          this.cadastro.valor_min_desconto = 0;
          this.cadastro.dthr_val_ini = "";
          this.cadastro.dthr_val_fim = "";
          this.cadastro.quantidade = null;
          this.cadastro.limite_uso = null;
          this.cadastro.documentos = null;
          this.cadastro.loading = false;
          this.cadastro.loja = "";
          this.cadastro.marketplace = false;
          this.cadastro.produto = [];
          this.cadastro.variacao = [];
          this.cadastro.error.loja = [];
          this.cadastro.error.valor_max_desconto = [];
          this.cadastro.error.valor_min_desconto = [];
          break;
        default:
          break;
      }
    },
  },
});
